<template>
<div class="row"> 
    
    <Select2
        :parent-id="'#'+id"
        :show-search="false"
        containerClass="col-6"
        :name="'amount-type-'+id+index"
        :multiple="false"
        :label="$t('label.type')"
        v-model="type"
        >
        <option v-for="type in TYPES" :value="type.value" :key="id+'_'+index+'_'+type.value">
            {{ type.name }}
        </option>
    </Select2>
    <InputNumber v-if="type === PERCENT"
        name="value_number"
        type="number"
        :label="$t('label.value')"
        :isRequired="true" size="lg"
        v-model="amount"
        :min="0"
        containerClass="col-6"
        :max="100"
    >
        <template #rightAddon>
            <span class="position-absolute end-0 top-50 translate-middle-y me-5 text-muted fw-bolder"> {{ '%'  }} </span>
        </template>
    </InputNumber>
    <InputAmount v-if="type === AMOUNT"
        :label="$t('label.value')"
        :number="amount"
        :iso="defaultCurrency?.symbol"
        :required="true"
        @amount="getAmount"
        containerClass="col-6"/>
</div>
</template>
<script setup>
import InputAmount from '@/components/InputAmount.vue';
import InputNumber from '@/components/InputNumber.vue';
import Select2 from '@/components/Select2.vue';
import i18n from '@/plugins/i18n';
import { computed , watch} from 'vue';
import { useStore } from 'vuex';

const store = useStore()

const AMOUNT = "amount"
const PERCENT = "percent"
const TYPES = [
    {name: i18n.global.t('type.amount'), value: AMOUNT},
    {name: i18n.global.t('type.percent'), value: PERCENT}
]

const props = defineProps({
    id:{type: String, default:'select_id'},
    index:{type: String, default:'test'}
})

const amount = defineModel('amount')
const type = defineModel('type')

watch(amount, (newVal, oldVal) => {
  if (isNaN(newVal)) {
    amount.value = oldVal || 0;
  }
});
const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency']) ?? {symbol: "CFA"}

function getAmount(val){
    amount.value = val
}
</script>